<template>    
    <v-form ref="form">
        <v-dialog v-if="isView" v-model="isView" persistent>        
            <v-card class="mt-3 pa-1">
                <Title title="グループユーザー">
                    <v-spacer />
                    <TitleButton
                        color="primary"
                        icon="mdi-floppy"
                        name="保存"
                        @click="onClickSave()" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView=false" />
                </Title>
                <v-container fluid>
                    <v-item-group>
                        <div class="d-flex flex-no-wrap mb-2">
                            <v-avatar size="62" rounded>
                                <v-img v-if="targetUser.userInfo.avaterURL != ''" :src="targetUser.userInfo.avaterURL"/>
                                <v-img v-else src="@/assets/no_avater_image.png"/>
                            </v-avatar>
                            <div>
                                <v-card-title class="subtitle-2 text-no-wrap" v-text="targetUser.userInfo.userName" />
                            </div>
                        </div>
                    </v-item-group>
                    <v-divider />
                    <v-row>
                        <v-col>
                            <span class="caption">
                                このユーザーは、他のメンバーに対して次の権限を持ちます。<br/>
                                あなたは各権限をクリックして、このユーザーの権限を変更出来ます。
                            </span>
                            <v-card outlined class="mt-1">
                                <v-card-text class="pa-1">
                                    <div>
                                        <v-chip 
                                            v-for="authority in editValues.authorities" 
                                            :key="authority.authority.key" 
                                            class="ma-1" 
                                            :color="authority.enable ? 'primary' : ''"
                                            @click="authority.enable = !authority.enable">
                                            {{authority.authority.text}}
                                        </v-chip>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card> 
        </v-dialog>
    </v-form>
</template>

現在、このコンポーネントは未使用！！！！！

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Title,
            TitleButton
        },
        props: [
        ],
        computed: {
            userUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            userData: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            authorities: function () {
                return this.$store.getters["managementItems/groupMemberAuthorities"]
            }
        },
        data: function () {
            return {
                isView:false,
                editValues: null,
                targetUser: null,
            }
        },
        methods: {
            show: function(user){
                console.log("MaintenanceGroupUser.show", user)
                this.targetUser = user
                this.editValues = {
                    authorities: []
                }
                for (var i=0; i<this.authorities.length; i++) {
                    var enable = false
                    if (user.body.authorities.findIndex((v)=>v == this.authorities[i].key) >= 0) {
                        enable = true
                    }
                    this.editValues.authorities.push(
                        {
                            authority: this.authorities[i],
                            enable: enable
                        }
                    )
                }
                this.isView = true
            },
            onClickSave: function () {

                const self = this

                try{
                    this.targetUser.body.authorities = []
                    for (var i=0; i<this.editValues.authorities.length; i++) {
                        if (this.editValues.authorities[i].enable) {
                            this.targetUser.body.authorities.push(this.editValues.authorities[i].authority.key)
                        }
                    }

                    this.targetUser.body.updatedDateTime = this.df_currentDateTime()

                    var batch = db.batch()

                    // グループユーザーの設定値更新
                    var docGroupUser = db.collection("users").doc(this.userUID).collection("groups").doc(""+this.targetUser.body.groupNo).collection("users").doc(this.targetUser.body.userUID)
                    batch.set(docGroupUser, this.targetUser.body)

                    batch.commit().then(function(){
                        self.isView = false
                        self.$store.commit("notification", {message:"グループユーザーを更新しました。"})
                    }).catch(function(error){
                        console.log(error)
                        self.$store.commit("notification", {message:"グループユーザーの更新に失敗しました。", isError:true})
                        self.mi_writeLog("MaintenanceGroupUser/onClickSave", "グループユーザーの更新に失敗しました。(1)("+error+")")
                    })

                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"グループユーザーの更新に失敗しました。", isError:true})
                    self.mi_writeLog("MaintenanceGroupUser/onClickSave", "グループユーザーの更新に失敗しました。(2)("+error+")")
                }
            },
        }
    }
</script>
